export function parseTimestamp(accessUntil: string): Date | null {
  try {
    return new Date(accessUntil);
  } catch {
    return null;
  }
}
